import { validateIBAN as apiValidateIBAN } from '../../lib/services/mobivers/api';
import { IBANCheck } from '../../types/api';
import { AppStore, DispatchThunkAny } from '../../types/redux';

export const BANK_VALIDATION_VALIDATE_IBAN = 'BANK_VALIDATION_VALIDATE_IBAN';
export const BANK_VALIDATION_VALIDATE_IBAN_DONE = 'BANK_VALIDATION_VALIDATE_IBAN_DONE';
export const BANK_VALIDATION_VALIDATE_IBAN_CANCEL = 'BANK_VALIDATION_VALIDATE_IBAN_CANCEL';
export const BANK_VALIDATION_VALIDATE_IBAN_FAILED = 'BANK_VALIDATION_VALIDATE_IBAN_FAILED';

export function validateIBAN(
	IBAN: string
): (dispatch: DispatchThunkAny, getState: any) => void {
	return async (dispatch: DispatchThunkAny, getState: any) => {
		const store: AppStore = { dispatch, getState };
		try {
			dispatch({ type: BANK_VALIDATION_VALIDATE_IBAN, payload: { IBAN } });
			const result: IBANCheck = await apiValidateIBAN(store, IBAN);
			// Refresh state to skip validation the IBAN if it has been changed while
			// we were performing the API call
			if (IBAN === getState().bankValidation.IBAN) {
				dispatch({ type: BANK_VALIDATION_VALIDATE_IBAN_DONE, payload: result });
			}
		} catch (error) {
			dispatch({
				type: BANK_VALIDATION_VALIDATE_IBAN_FAILED,
				payload: error,
			});

			return error;
		}
	};
}

export function cancelValidation(): (
	dispatch: DispatchThunkAny,
	getState: any
) => void {
	return (dispatch: DispatchThunkAny, getState: any) => {
		const {
			bankValidation: { isValid },
		} = getState();
		// A null isValid means a validation is in progress,
		// True means a previous validated IBAN that we must discard
		if (isValid !== false) {
			dispatch({ type: BANK_VALIDATION_VALIDATE_IBAN_CANCEL });
		}
	};
}
